import { useForm } from "react-hook-form";
import { CustomFormField } from "../../../../utilis/component/CustomFormElement";
import {
  Button,
  Checkbox,
  CircularProgress,
  debounce,
  FormControlLabel,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
} from "@mui/material";
import CustomTableBody from "../../../../utilis/component/CustomTableBody";
import { useMutation } from "react-query";
import {
  cancelEncounterService,
  getAllDoctor,
  getEncounter,
  getPatientByEncounter,
} from "./service";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { clinicId } from "../../../../constants";
import { RequestType, responseType } from "./types";
import moment from "moment";
import {
  formatLocalDate,
  formatLocalTime,
} from "../../../../utilis/methods/localDateTime";
import {
  Close,
  CloudDownload,
  CloudUpload,
  Edit,
  RemoveRedEye,
} from "@mui/icons-material";
import usePopup from "../../../../hooks/usePopup";
import PatientDetails from "./PatientDetails";
import {
  // useLocation,
  useNavigate,
} from "react-router-dom";
import moduleRoutes from "../../../../routes/moduleRouteList";
import patientCareRouteList from "../../../../PatientCare/routeList";
import { FormOnChangeEventType } from "../../../../EMR/types";
import UploadDocuments from "../../../../EMR/components/UploadDocuments";
import dashboardRouteList from "../../../routeList";
import {
  geDisChargeSummary,
  geDisChargeSummaryv2,
} from "../../../../EMR/components/ConsenForms/services";
import { setItem } from "../../../../utilis/methods/storage/storage";
import usePrint from "../../../../hooks/usePrint";
// import PageRouterList from "../../../../routes/routeList";
import { EmrDataProvider } from "../../../../EMR";
import PatientConsentForm from "../../../../EMR/components/ConsenForms/PatientConsentForm";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import useAuthentication from "@hooks/useAuthentication";
// import ConsentForm from "../ConsentForm";

const base = (window as any)._env_?.BASE_URL;

const Encounters = () => {
  const { control, reset } = useForm();
  const navigateto = useNavigate();
  const { printPdf, loading } = usePrint();
  const { user } = useAuthentication();
  const [selected, setSelected] = useState<number>(-1);
  const [openConsent, setOpenConsent] = useState(false);
  const [open, setOpen] = useState(false);
  const [upload, setUpload] = useState(false);
  const { CustomModal, showSnackbar } = usePopup();
  // const [selectedDetails, setSelectedDetails] = useState<{
  //   id: number | null;
  //   PatientId: number | null;
  // }>({
  //   id: null,
  //   PatientId: null,
  // });
  const [searchPayload, setSearchPayload] = useState<RequestType>({
    clinicId: clinicId,
    filter: {
      search: "",
      searchDate: moment().format("YYYY-MM-DD"),
      searchDateTo: moment().format("YYYY-MM-DD"),
      doctor: null,
      status: 1,
    },
    pageNumber: 0,
    pageSize: 25,
    sortField: "",
    sortOrder: "asc",
  });
  // const location = useLocation();
  const { mutate: getalldoctors, data: doctorsList } =
    useMutation(getAllDoctor);
  const {
    mutate: searchEncounter,
    data,
    isLoading: dataLoading,
  } = useMutation(getEncounter);
  const { mutate: getPatientData, data: patientData } = useMutation(
    getPatientByEncounter,
    {
      onSuccess: () => {
        setOpen(true);
      },
    },
  );
  const { mutate: cancelEncounter } = useMutation(cancelEncounterService, {
    onSuccess: (data) => {
      data.responseIndicator == "success" &&
        setSearchPayload((prev) => ({
          ...prev,
          filter: {
            ...prev.filter,
            search: "",
          },
        }));
      const msg =
        data.responseIndicator == "success"
          ? "Encounter cancelled successfully"
          : "Failed to cancel encounter";
      const variant = data.responseIndicator == "success" ? "success" : "error";
      showSnackbar({
        message: msg,
        open: true,
        variant: variant,
        duration: 1000,
      });
    },
  });

  const { mutate: downloadeDisCharge, isLoading: disChargeSummaryLoading } =
    useMutation(geDisChargeSummary, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          printPdf(result.response);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
    });

  const { mutate: downloadeDisChargev2, isLoading: disChargeSummaryLoadingv2 } =
    useMutation(geDisChargeSummaryv2, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          printPdf(result.response);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
    });

  const handleUpload = (id: number, PatientId: number, emrNo: string) => {
    // setSelectedDetails({ id, PatientId });
    navigateto(
      `${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.reception}/${id}/${PatientId}?emrno=${emrNo}`,
    );
    setUpload(true);
  };
  const onChange = (e: FormOnChangeEventType) => {
    setSearchPayload((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [e.target.name]: e?.target?.value,
      },
    }));
  };
  const searchOnText = debounce((e: FormOnChangeEventType) => {
    setSearchPayload((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [e.target.name]: e.target.value,
      },
    }));
  }, 500);
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const pageSize = parseInt(event.target.value, 10);
    setSearchPayload((prev) => ({
      ...prev,
      pageNumber: 0,
      pageSize,
    }));
  };
  const handleChangePage = (_: unknown, pageNumber: number) => {
    setSearchPayload({
      ...searchPayload,
      pageNumber,
    });
  };

  useEffect(() => {
    getalldoctors();
  }, []);

  useEffect(() => {
    navigateto(
      `${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.reception}`,
    );
    reset({ status: 1 });
  }, []);
  useEffect(() => {
    searchEncounter(searchPayload);
  }, [searchPayload]);

  const handleNaviagte = (emrno: string, id: number) => {
    navigateto(
      `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.patientEnounter}/${emrno}?encounterid=${id}`,
      {
        state: { encounter: true }, // Pass state here
      },
    );
    setItem("selectedTab", "2");
  };

  const handleNavigateToConsent = () => {
    setOpenConsent(true);
    setUpload(false);
  };

  const handleGetAll = (e: any) => {
    if (e.target.checked) {
      setSearchPayload((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          searchDate: null,
        },
      }));
    } else {
      setSearchPayload((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          searchDate: moment().format("YYYY-MM-DD"),
        },
      }));
    }
  };

  const editPermission = { admin: true, coder: true };

  return (
    <Paper className="p-3">
      <CustomModal title="Patient details" open={open} setOpen={setOpen}>
        <PatientDetails Patientdata={patientData} />
      </CustomModal>
      <CustomModal
        title="Consent form"
        open={openConsent}
        setOpen={setOpenConsent}
      >
        <EmrDataProvider>
          <div className="w-[80vw] max-h-[90dvh] overflow-y-auto py-2">
            <PatientConsentForm />
          </div>
        </EmrDataProvider>
      </CustomModal>
      <CustomModal title="Uploads" open={upload} setOpen={setUpload}>
        <div className="w-[60vw]">
          <div className="flex justify-end p-2">
            {user?.region == "UAE_REGION" && (
              <Button onClick={handleNavigateToConsent}>
                download consent form
              </Button>
            )}
            {/* <ConsentForm /> */}
          </div>
          <UploadDocuments files=".pdf" />
        </div>
      </CustomModal>
      <form>
        <div className="grid grid-cols-12 gap-2 my-2">
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="input"
              name="search"
              rules={{ required: false, onChange: searchOnText }}
              fieldProps={{ label: "search Encounter", type: "text" }}
            />
          </div>

          <div className="col-span-3">
            <CustomFormField
              control={control}
              element="radio"
              name="status"
              radioProps={{ row: true }}
              radios={[
                { label: "Encountered", value: 1 },
                { label: "cancelled", value: 0 },
              ]}
              rules={{ required: false, onChange }}
              fieldProps={{ label: "" }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="autocomplete"
              name="doctor"
              options={doctorsList || []}
              rules={{ required: false, onChange }}
              fieldProps={{ label: "Registered By :" }}
              autocompleteProps={{
                getOptionLabel: (option: { id: number; name: string }) =>
                  option?.name,
                isOptionEqualToValue: (option, value) => {
                  return option?.id == value?.id;
                },
              }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              name="searchDate"
              element="datepicker"
              dateFormat="YYYY-MM-DD"
              calenderProps={{ maxDate: dayjs(moment().format("YYYY-MM-DD")) }}
              fieldProps={{ label: "From Date" }}
              rules={{ required: false, onChange }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              name="searchDateTo"
              dateFormat="YYYY-MM-DD"
              element="datepicker"
              fieldProps={{ label: "To Date" }}
              rules={{ required: false, onChange }}
              calenderProps={{ defaultValue: dayjs(new Date()) }}
            />
          </div>
          <div className="col-span-2">
            <FormControlLabel
              control={<Checkbox onChange={handleGetAll} />}
              label="All encounters"
            />
          </div>
        </div>
      </form>
      <Table size="small">
        <TableHead
          sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
        >
          <TableRow>
            {headings.map((item: string) => {
              return (
                <TableCell
                  align={item === "Date" ? "center" : "left"}
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                >
                  {item}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <CustomTableBody
          alert={"No Encounters"}
          dataLoading={dataLoading}
          isData={Boolean(data?.response?.registration?.length)}
          totalSpan={{ col: headings.length, row: 3 }}
        >
          {data?.response?.registration?.map(
            (item: responseType, index: number) => {
              return (
                <>
                  <TableRow>
                    <TableCell>
                      {searchPayload.pageNumber * searchPayload.pageSize +
                        (index + 1)}
                    </TableCell>
                    <TableCell align="center">
                      <div className="flex items-center justify-center gap-2">
                        {/* Date block */}
                        <div className="flex items-center gap-1">
                          <CalendarMonthIcon color="primary" fontSize="small" />
                          {formatLocalDate(item.date)}
                        </div>

                        {/* Time block */}
                        <div className="flex items-center gap-1">
                          <AccessTimeIcon color="success" fontSize="small" />
                          {formatLocalTime(item.date)}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>{item.emrNo}</TableCell>
                    <TableCell>{item.patientName}</TableCell>
                    <TableCell>
                      {item.doctor}
                      <br></br>({item.department})
                    </TableCell>
                    <TableCell>
                      {item.paymentType == 0 ? "cash" : "insurance"}
                    </TableCell>
                    <TableCell>{item.purpose}</TableCell>
                    <TableCell>
                      {item.status > 0 ? "encountered" : "cancelled"}
                    </TableCell>
                    <TableCell>
                      <div className="flex gap-3">
                        <IconButton onClick={() => getPatientData(item?.id)}>
                          {" "}
                          <Tooltip title="view details">
                            <RemoveRedEye color="error" />
                          </Tooltip>
                        </IconButton>
                        {(Boolean(
                          editPermission[
                            user?.groupName?.toLowerCase() as keyof typeof editPermission
                          ],
                        )
                          ? true
                          : Boolean(
                              !item?.isConsulted && item.status == 1,
                            )) && (
                          <IconButton
                            onClick={() => {
                              handleNaviagte(item.emrNo, item.id);
                            }}
                          >
                            <Tooltip title="edit encounter">
                              <Edit
                                className="cursor-pointer"
                                color="primary"
                              />
                            </Tooltip>
                          </IconButton>
                        )}
                        {!item?.isConsulted && item.status == 1 && (
                          <IconButton
                            onClick={() => {
                              cancelEncounter({
                                id: item.id,
                                status: 0,
                                clinicId,
                              });
                            }}
                          >
                            <Tooltip title="cancel encounter">
                              <Close color="error" />
                            </Tooltip>
                          </IconButton>
                        )}
                        {item.status == 1 && (
                          <Tooltip title="upload documents">
                            <IconButton
                              onClick={() => {
                                // navigateto(
                                //   `${base}react/main/${moduleRoutes.dashboard}/${PageRouterList.reception}`,
                                //   { state: { encounterId: selectedDetails.id } }
                                // );
                                handleUpload(
                                  item.id,
                                  item.patientId,
                                  item.emrNo,
                                );
                              }}
                            >
                              {" "}
                              <CloudUpload color="primary" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {item.status == 1 && (
                          <div className="flex items-center justify-center">
                            <Tooltip title="Download discharge summary">
                              {(disChargeSummaryLoading ||
                                disChargeSummaryLoadingv2 ||
                                loading) &&
                              selected == item.id ? (
                                <CircularProgress size={18} color="primary" />
                              ) : (
                                <IconButton
                                  disabled={
                                    disChargeSummaryLoading ||
                                    disChargeSummaryLoadingv2
                                  }
                                  onClick={() => {
                                    user?.codetype == "CPT"
                                      ? downloadeDisCharge({
                                          id: item.id,
                                          tenetClinicId: Number(
                                            user?.tenantClinicId,
                                          ),
                                        })
                                      : downloadeDisChargev2({
                                          id: item.id,
                                          insname: String(""),
                                        });
                                    setSelected(item.id);
                                  }}
                                >
                                  <CloudDownload color="primary" />
                                </IconButton>
                              )}
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                </>
              );
            },
          )}
        </CustomTableBody>
      </Table>
      <TablePagination
        count={data?.response?.totalCount || 0}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPage={searchPayload.pageSize || 0}
        page={searchPayload.pageNumber || 0}
      ></TablePagination>
    </Paper>
  );
};

export default Encounters;

const headings = [
  "Sl No",
  "Date",
  "EMR No",
  "Patient Name",
  "Doctor Name",
  "Patient Type",
  "Purpose",
  "Status",
  "Action",
];
